"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.space = void 0;
const immer_1 = require("immer");
const actions = __importStar(require("../../../shared/store/action_constants"));
const defaultSpace = {
    spaceList: [],
    curSpaceInfo: null,
    spaceFeatures: null,
    quitSpaceId: '',
    loading: false,
    reconnecting: false,
    connected: false,
    err: null,
    screenWidth: null,
    sideBarVisible: true,
    shortcutKeyPanelVisible: false,
    isApiPanelOpen: false,
    isSideRecordOpen: false,
    isRecordFullScreen: false,
    marketplaceApps: [],
    previewModalVisible: false,
    activeId: null,
    envs: {}
};
exports.space = (0, immer_1.produce)((spaceDraft = defaultSpace, action) => {
    switch (action.type) {
        case actions.SET_SPACE_LIST: {
            spaceDraft.spaceList = action.payload;
            return spaceDraft;
        }
        case actions.SET_QUIT_SPACE_ID: {
            spaceDraft.quitSpaceId = action.payload;
            return spaceDraft;
        }
        case actions.SET_SPACE_ERR: {
            spaceDraft.err = action.payload;
            return spaceDraft;
        }
        case actions.SET_SPACE_LOADING: {
            spaceDraft.loading = action.payload;
            return spaceDraft;
        }
        case actions.SET_SPACE_INFO: {
            spaceDraft.curSpaceInfo = Object.assign({}, spaceDraft.curSpaceInfo, action.payload);
            return spaceDraft;
        }
        case actions.SET_SPACE_FEATURES: {
            spaceDraft.spaceFeatures = Object.assign({}, spaceDraft.spaceFeatures, action.payload);
            return spaceDraft;
        }
        case actions.SET_RECONNECTING: {
            spaceDraft.reconnecting = action.payload;
            return spaceDraft;
        }
        case actions.SET_CONNECTED: {
            spaceDraft.connected = action.payload;
            return spaceDraft;
        }
        case actions.SET_SCREEN_WIDTH: {
            spaceDraft.screenWidth = action.payload;
            return spaceDraft;
        }
        case actions.SET_SIDEBAR_VISIBLE: {
            spaceDraft.sideBarVisible = action.payload;
            return spaceDraft;
        }
        case actions.SET_PREVIEW_MODAL_VISIBLE: {
            spaceDraft.previewModalVisible = action.payload;
            return spaceDraft;
        }
        case actions.SET_SHORTCUT_KEY_PANEL_VISIBLE: {
            spaceDraft.shortcutKeyPanelVisible = action.payload;
            return spaceDraft;
        }
        case actions.TOGGLE_API_PANEL: {
            spaceDraft.isApiPanelOpen = action.payload != null ? action.payload : !spaceDraft.isApiPanelOpen;
            return spaceDraft;
        }
        case actions.TOGGLE_SIDE_RECORD_PANEL: {
            spaceDraft.isSideRecordOpen = action.payload != null ? action.payload : !spaceDraft.isSideRecordOpen;
            return spaceDraft;
        }
        case actions.TOGGLE_RECORD_PANEL_FULL_SCREEN: {
            spaceDraft.isRecordFullScreen = action.payload != null ? action.payload : !spaceDraft.isRecordFullScreen;
            return spaceDraft;
        }
        case actions.SET_MARKETPLACE_APPS: {
            spaceDraft.marketplaceApps = action.payload;
            return spaceDraft;
        }
        case actions.SET_ACTIVE_SPACE_ID: {
            spaceDraft.activeId = action.payload;
            if (spaceDraft.curSpaceInfo) {
                spaceDraft.curSpaceInfo.lastUpdateTime = 0;
            }
            return spaceDraft;
        }
        case actions.SET_ENVS: {
            spaceDraft.envs = action.payload;
            return spaceDraft;
        }
        default:
            return spaceDraft;
    }
}, defaultSpace);
//# sourceMappingURL=space.js.map